module.exports = __webpack_public_path__ + "img/logo-orange-full.36d6c1a5.png";